<div>
  <div class="topo-line"></div>
  <app-menu></app-menu>
  <div class="topo-space"></div>
  <app-title></app-title>
</div>
